export default "__VITE_ASSET__DeUXgApr__"